var sb = require('@sb/util')

export default {
	name: 'Emoji',
	props: ['emojiCode', 'byType'],
	render () {
		var emojiCode = this.emojiCode
		// not an emoji
		if (sb.size(emojiCode) < 3) return null
		var emojiText = emojiCode.replace(/:/g, '')
		// use i tag instead of img, because img without src has a border (can't be styled)
		return <i data-tooltip={emojiCode} class={`emoji emoji--${emojiText}`}></i>
	},
}
